import React from 'react';
import { useParams } from 'react-router-dom';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import EncoderViewer from '../components/EncoderViewer';

export default function EncoderDetailPage() {
  const { encoderId, pacienteId } = useParams();

  return (
    <DashboardLayout>
      <EncoderViewer encoderId={encoderId} pacienteId={pacienteId} />
    </DashboardLayout>
  );
}
